import { Resolver } from '@spotify-internal/remote-config-resolver';
import { properties } from './properties';

type Options = {
  transport: Resolver.Config['transport'];
};

export function createResolver({ transport }: Options) {
  return new Resolver({
    clientId: 'mrkt-web',
    transport,
    properties,
  });
}
